import ApplicationAdapter from './application';

export default class ListenerAdapter extends ApplicationAdapter {
  namespace = 'api/v2/social_listening';
}
